import React from 'react';
import classNames from 'classnames';
import Icon, { ICONS, COLORS } from './icon';

export const ALIGNMENTS = { LEFT: 0, CENTER: 1, RIGHT: 2 };

interface Props {
	undo: () => void;
	redo: () => void;
	handleFontStyle: (e: any, style: string) => void;
	toggleAlignment: (e?: any) => void;
	toggleOL: (e?: any) => void;
	toggleUL: (e?: any) => void;
	toggleFontPopover: (e?: any) => void;
	activeStates: string[];
	currentBlockAlignment: number;
	fontPopoverOpen: boolean;
	fontPopoverHidden: boolean;
	fontSize: number;
	handleRangeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	fontColors: Record<string, { color: string }>;
}

export default function RichTextEditorControls(props: Props) {
	const {
		undo, redo, handleFontStyle, toggleAlignment, toggleOL, toggleUL,
		toggleFontPopover, activeStates, currentBlockAlignment, fontPopoverOpen,
		fontPopoverHidden, fontSize, handleRangeChange, fontColors,
	} = props;

	return (
		<>
			<div className="editor-controls-container editor-left">
				<button className="undo" onMouseDown={undo} title="undo"><Icon name={ICONS.UNDO} size={17} color={COLORS.GRAY} /></button>
				<button className="redo" onMouseDown={redo} title="redo"><Icon name={ICONS.REDO} size={17} color={COLORS.GRAY} /></button>
			</div>
			<div className="editor-controls-container editor-center">
				<button className={classNames('bold', { active: activeStates.includes('BOLD') })} onMouseDown={(e) => handleFontStyle(e, 'BOLD')} title="bold"><Icon name={ICONS.BOLD} size={17} color={COLORS.GRAY} /></button>
				<button className={classNames('italic', { active: activeStates.includes('ITALIC') })} onMouseDown={(e) => handleFontStyle(e, 'ITALIC')} title="italic"><Icon name={ICONS.ITALIC} size={17} color={COLORS.GRAY} /></button>
				<button className={classNames('underline', { active: activeStates.includes('UNDERLINE') })} onMouseDown={(e) => handleFontStyle(e, 'UNDERLINE')} title="underline"><Icon name={ICONS.UNDERLINE} size={17} color={COLORS.GRAY} /></button>
			</div>
			<div className="editor-controls-container editor-center">
				<button className="align" onMouseDown={toggleAlignment} title="align">
					{currentBlockAlignment === ALIGNMENTS.LEFT && <Icon name={ICONS.ALIGN_LEFT} size={17} color={COLORS.GRAY} />}
					{currentBlockAlignment === ALIGNMENTS.CENTER && <Icon name={ICONS.ALIGN_CENTER} size={17} color={COLORS.GRAY} />}
					{currentBlockAlignment === ALIGNMENTS.RIGHT && <Icon name={ICONS.ALIGN_RIGHT} size={17} color={COLORS.GRAY} />}
				</button>
				<button className="ol" onMouseDown={toggleOL} title="list"><Icon name={ICONS.OL} size={17} color={COLORS.GRAY} /></button>
				<button className="ul" onMouseDown={toggleUL} title="bullets"><Icon name={ICONS.UL} size={17} color={COLORS.GRAY} /></button>
			</div>
			<div className="editor-controls-container editor-right">
				<div className={classNames('font-popover', { open: fontPopoverOpen, hidden: fontPopoverHidden })}>
					<div className="range-container">
						<span className="font-small">A</span>
						<div className="input-wrapper">
							<input type="range" min={10} max={48} step={1} value={fontSize} onChange={handleRangeChange} />
						</div>
						<span className="font-large">A</span>
					</div>
					<div className="colors-container">
						{Object.keys(fontColors).map((color: string) => (
							<button
								key={color}
								className={classNames({ active: activeStates.includes(color) })}
								onMouseDown={(e) => handleFontStyle(e, color)}
								style={{ backgroundColor: fontColors[color]!.color }}
							/>
						))}
					</div>
				</div>
				<button className={classNames('font', { active: fontPopoverOpen })} onMouseDown={toggleFontPopover}>
					<Icon name={ICONS.FONT} size={21} color={COLORS.GRAY} />
				</button>
			</div>
		</>
	);
}
